import { render } from "./Preferencias.vue?vue&type=template&id=1ba9712c&scoped=true"
import script from "./Preferencias.vue?vue&type=script&lang=js"
export * from "./Preferencias.vue?vue&type=script&lang=js"

import "./Preferencias.vue?vue&type=style&index=0&id=1ba9712c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1ba9712c"

export default script